
import { defineComponent } from "vue";
import { process_ecwalletReload, loadPaginatedECWalletHistory, process_ecwalletOTP } from "@/api/onlineshop";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { invalidateApiCache } from "@/api/common";
import OtpInput from "@/components/encashment/OtpInput.vue";

export default defineComponent({
  name: "ecwalletprocess",
  components: {
    OtpInput,
  },
  props: {
    widgetClasses: String,
  },
  data() {
    return {
      hasPendingECWalletOTP: false,
      optionsRadios: 1,
      totalAmount: "0",
      totalAmount2: 0,
      model_ecwallet_otp: "",
      isProcessingOTP: false,
      isProcessingReload: false,
      loading: true,
      ccode: "",
      currency: "",
      isAllowedECWallet: false,
      defaultAmounts: [100, 500, 1000, 5000, 10000, 20000, 50000, 100000],
      tanzaniaAmounts: [25000, 50000, 100000, 250000, 500000, 1250000],
    };
  },
  methods: {
    resetLocalStorageECWalletData() {
      invalidateApiCache("vecwallethistory");
    },
    async loadPaginatedECWalletHistory() {
      this.loading = true;
      const response = await loadPaginatedECWalletHistory(1);
      this.hasPendingECWalletOTP = response.data.hasPendingECWalletOTP;
      this.ccode = response.data.ccode;
      this.currency = response.data.currency;
      this.isAllowedECWallet = response.data.isShowECWalletReloadDiv;
      this.loading = false;
    },
    async cancel_ecwalletReload() {
      this.totalAmount = "0";
      this.totalAmount2 = 0;
    },
    async computeTotalAmount(amountClicked: number) {
      var totalAmount = this.totalAmount2;

      if (this.optionsRadios == 1) {
        totalAmount = Number(totalAmount) + Number(amountClicked);
      } else {
        totalAmount = Number(totalAmount) - Number(amountClicked);
      }

      if (totalAmount < 0) {
        totalAmount = 0;
      }

      this.totalAmount2 = totalAmount;
      this.totalAmount = String(totalAmount);
      return totalAmount;
    },
    async process_ecwalletReload() {
      this.loading = true;
      if (isNaN(this.totalAmount2) || this.totalAmount2 == 0) {
        this.isProcessingReload = true;
        Swal.fire({
          title: "",
          text: "Total must be greater than 0.",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
        });
        this.isProcessingReload = false;
        this.loading = false;
        return;
      } else {
        this.isProcessingReload = true;
        var param = { amount: this.totalAmount2 };
        const response = await process_ecwalletReload(param);

        if (response != null) {
          this.isProcessingReload = false;

          if (response.data.result == "SUCCESS") {
            Swal.fire({
              title: "",
              text: response.data.message,
              icon: "success",
              confirmButtonClass: "btn btn-secondary",
            });
            this.resetLocalStorageECWalletData();
            window.location.reload();
            return;
          } else if (response.data.result == "FAILED") {
            Swal.fire({
              title: "",
              text: response.data.message,
              icon: "error",
              confirmButtonClass: "btn btn-secondary",
            });
            this.loading = false;
            return;
          }
        }
      }
      this.loading = false;
    },
    async process_ecwalletOTP() {
      this.loading = true;
      this.isProcessingOTP = true;
      var param = { otp: this.model_ecwallet_otp };
      const response = await process_ecwalletOTP(param);
      if (response != null) {
        this.isProcessingOTP = false;

        if (response.data.result == "SUCCESS") {
          Swal.fire({
            title: "",
            text: response.data.message,
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
          });
          this.resetLocalStorageECWalletData();
          window.location.reload();
          return;
        } else if (response.data.result == "FAILED") {
          Swal.fire({
            title: "",
            text: response.data.message,
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
          });
          this.loading = false;
          return;
        }
      }
      this.loading = false;
    },
  },
  mounted() {
    this.loadPaginatedECWalletHistory();
  },
});
